var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none",
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.268.804C5.488.804.826 5.394.826 10.976c0 5.583 4.711 10.172 10.442 10.172 5.732 0 10.443-4.589 10.443-10.172C21.71 5.394 17.048.804 11.268.804zm0 21.196C5.051 22 0 17.08 0 10.976 0 4.873 5.051 0 11.268 0c6.217 0 11.269 4.92 11.269 10.976C22.537 17.032 17.534 22 11.268 22z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F00",
    d: "M12.871 14.732c0 .424.45.636 1.352.636l-.305 1.803H6.976l.304-1.803c.967 0 1.51-.252 1.603-.769l.636-3.738c0-.45-.437-.663-1.325-.663L8.5 8.435h5.459l-1.087 6.297zm1.617-8.988c0 .279-.053.53-.16.77-.105.238-.25.45-.423.636-.186.185-.398.33-.636.424-.239.106-.504.159-.769.159s-.53-.053-.768-.16c-.239-.105-.45-.251-.636-.423-.185-.186-.331-.398-.424-.637-.106-.238-.159-.503-.159-.769 0-.278.053-.53.16-.768.105-.239.25-.451.423-.637.185-.185.397-.331.636-.424.239-.093.49-.159.755-.159s.53.053.769.16c.238.105.45.251.636.423.185.186.33.398.424.637.092.238.172.503.172.768z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H7.512V13.415H0z",
    transform: "translate(6.976 3.756)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramInfo);
export default __webpack_public_path__ + "static/media/program-info.2d771d9e8e6e2fe8626c9fd563279e07.svg";
export { ForwardRef as ReactComponent };